<template>
    <div class="hot-spot-analysis-wrap">
        <TopOptBar
            @langSelect="langSelect"
            @updateTime="updateTime"
            @quesTypeChange="quesTypeChange"
            @channelChange="channelChange"
            @dateNowClick="dateNowClick"
        />
        <HotSpotPannel
            v-show="!noDataTip"
            :title="sceneTitle"
            :options="satisfOptions"
            initVal="1"
            @exportHandle="exportHotScene"
            @menuClick="sceneOptionSelect"
        >
            <div class="scene-hot-box">
                <div class="first-scene-content">
                    <div class="scene-title">{{ firstScene }}</div>
                    <Table class="scene-table-list" :config="sceneTableConfig.firstScene" :dataset="firstSceneData" @pageChange="firstPageChange" />
                    <div class="page-control">
                        <PageControl :total="totalFirstScene" :curPage="curPageFirst" :pageLength="10" @pageClick="firstPageChange" />
                    </div>
                </div>
                <div class="second-scene-content">
                    <div class="scene-title">{{ secondScene }}</div>
                    <Table class="scene-table-list" :config="sceneTableConfig.firstScene" :dataset="secondScendData" @pageChange="secondPageChange" />
                    <div class="page-control">
                        <PageControl :total="totalSecondScene" :curPage="curPageSecond" :pageLength="10" @pageClick="secondPageChange" />
                    </div>
                </div>
            </div>
        </HotSpotPannel>
        <HotSpotPannel
            v-show="!noDataTip"
            :title="questionTitle"
            :options="quesSatisfOptions"
            initVal="1"
            @exportHandle="exportHotQues"
            @menuClick="quesOptionSelect"
        >
            <QuesSatisfaction
                @noDataShow="noDataShowHandle"
                :order="quesSelectVal"
                :startDate="startTime"
                :endDate="endTime"
                :quesType="quesType"
                :channelType="channelType"
                :langType="langType"
                @sceneSelected="sceneSelected"
            />
        </HotSpotPannel>
        <div class="no-data-tips" v-show="noDataTip">
            {{ noDataLabel }}
        </div>
    </div>
</template>

<script>
import TopOptBar from "./components/TopOperateBar";
import HotSpotPannel from "@/views/zhiji/components/pagesPanel/HotSpotPannel";
import Table from "@/views/zhiji/bComponents/table/Table";
import QuesSatisfaction from "./components/QuesSatisfaction";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";

import { sceneTableConfig, satisfOptions, quesSatisfOptions } from "./satisfConfig.js";
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "Satisfaction",
    components: {
        TopOptBar,
        HotSpotPannel,
        Table,
        QuesSatisfaction,
        PageControl
    },
    data() {
        return {
            curPageFirst: 1,
            curPageSecond: 1,
            curPageLen: 10,
            startTime: this.getYesterday().start,
            endTime: this.getYesterday().end,
            quesType: "",
            channelType: "",
            firstSceneData: [],
            totalFirstScene: 0,
            secondScendData: [],
            totalSecondScene: 0,
            currentSceneId: "",
            langType: "",
            sceneSelectVal: "1",
            quesSelectVal: "1",
            noDataTip: true
        };
    },
    computed: {
        satisfOptions() {
            return satisfOptions();
        },
        quesSatisfOptions() {
            return quesSatisfOptions();
        },
        sceneTableConfig() {
            return sceneTableConfig();
        },
        sceneTitle() {
            return this.$t("zhiji.satisfaction.senceSatisfy");
        },
        questionTitle() {
            return this.$t("zhiji.satisfaction.quesSatisfy");
        },
        firstScene() {
            return this.$t("zhiji.hotSpot.firstScene");
        },
        secondScene() {
            return this.$t("zhiji.hotSpot.secondScene");
        },
        noDataLabel() {
            return this.$t("zhiji.common.noData");
        }
    },
    mounted() {
        this.querySatisfySceneData();
    },
    watch: {
        sceneSelectVal() {
            this.resetCurPage();
            this.querySatisfySceneData();
        }
    },
    methods: {
        querySatisfySceneData() {
            this.getSatisfySceneData(1);
            this.getSatisfySceneData(2);
        },
        getSatisfySceneData(level) {
            let reqData = {
                order: this.sceneSelectVal,
                startTime: this.startTime,
                endTime: this.endTime,
                quesType: this.quesType,
                channelType: this.channelType,
                curPageLen: this.curPageLen,
                langType: this.langType,
                page: level == 1 ? this.curPageFirst : this.curPageSecond,
                sceneLevel: level
            };
            this.zhiji.requestByServiceName("querySatisfySceneData", reqData).then(result => {
                level == 1 ? this.renderFirstData(result) : this.renderSecondData(result);
            });
        },
        renderFirstData(result) {
            this.totalFirstScene = result.count;
            this.firstSceneData.splice(0, this.firstSceneData.length, ...result.hotSceneData);
        },
        renderSecondData(result) {
            this.totalSecondScene = result.count;
            this.secondScendData.splice(0, this.secondScendData.length, ...result.hotSceneData);
        },
        updateTime(date) {
            date.type == "start" ? (this.startTime = date.value) : (this.endTime = date.value);
            this.resetCurPage();
            this.querySatisfySceneData();
        },
        dateNowClick(data) {
            this.startTime = data.start;
            this.endTime = data.end;
            this.resetCurPage();
            this.querySatisfySceneData();
        },
        quesTypeChange(data) {
            this.quesType = data.value;
            this.resetCurPage();
            this.querySatisfySceneData();
        },
        channelChange(data) {
            this.channelType = data.value;
            this.resetCurPage();
            this.querySatisfySceneData();
        },
        langSelect(data) {
            this.langType = data.value;
            this.resetCurPage();
            this.querySatisfySceneData();
        },
        resetCurPage() {
            this.curPageFirst = 1;
            this.curPageSecond = 1;
        },
        firstPageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPageFirst == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPageFirst = data.curPage;

            this.getSatisfySceneData(1);
        },
        secondPageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPageSecond == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPageSecond = data.curPage;

            this.getSatisfySceneData(2);
        },
        sceneSelected(sceneId) {
            this.currentSceneId = sceneId;
        },
        exportHotScene() {
            let reqUrl = URLs.EXPORT_SATISFACTION_SENCE + `?start_time=${this.startTime}&end_time=${this.endTime}`;

            let reqUrlParam = `&channel=${this.reqDataHandle().channelType}
                &question_type=${this.reqDataHandle().quesType}
                &set_level=1,2
                &${getOrderData(this.sceneSelectVal)}
                &language=${this.reqDataHandle().langType}`;

            reqUrlParam = reqUrlParam.replace(/\s+/g, "");

            reqUrl = reqUrl + reqUrlParam;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        exportHotQues() {
            let reqUrl = URLs.EXPORT_SATISFACTION_QUES + `?start_time=${this.startTime}&end_time=${this.endTime}`;

            let reqUrlParam = `&channel=${this.reqDataHandle().channelType}
                &question_type=${this.reqDataHandle().quesType}
                &set_id=${this.currentSceneId}
                &${getOrderData(this.quesSelectVal)}
                &language=${this.reqDataHandle().langType}`;

            reqUrlParam = reqUrlParam.replace(/\s+/g, "");

            reqUrl = reqUrl + reqUrlParam;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        reqDataHandle() {
            return {
                langType: !!this.langType && this.langType != "all" ? this.langType : "",
                channelType: !!this.channelType && this.channelType != "all" ? this.channelType : "",
                quesType: !!this.quesType && this.quesType != "all" ? this.quesType : ""
            };
        },
        sceneOptionSelect(data) {
            this.sceneSelectVal = data.value;
        },
        quesOptionSelect(data) {
            this.quesSelectVal = data.value;
        },
        getYesterday() {
            let seconds = new Date(Date.now() - getDayMilliseconds() * 1);
            let start = this.zhiji.dateFormat(seconds, "YYYY/MM/DD 00:00");
            let end = this.zhiji.dateFormat(seconds, "YYYY/MM/DD 23:59");

            return {
                start: start.replace(/\//g, "-"),
                end: end.replace(/\//g, "-")
            };
        },
        noDataShowHandle(data) {
            this.noDataTip = data;
        }
    }
};

// 一天的秒数
function getDayMilliseconds() {
    return 24 * 60 * 60 * 1000;
}

function getOrderData(data) {
    let sortObj = {
        "1": "good_rate", // 好评
        "2": "good_rate",
        "3": "all_num", // 评价量
        "4": "all_num",
        "5": "good_num", // 满意评价数
        "6": "good_num",
        "7": "question_num", // 提问总数
        "8": "question_num",
        "9": "evaluation_rate", // 评价率
        "10": "evaluation_rate"
    };

    let orderObj = {};

    for (let i in sortObj) {
        let num = Number(i);
        // 奇数-升序 偶数-降序
        orderObj[i] = num % 2 === 0 ? "asc" : "desc";
    }

    return `sort_by=${sortObj[data]}&order=${orderObj[data]}`;
}
</script>

<style lang="scss" scoped>
.hot-spot-analysis-wrap {
    padding: 16px;
    background: #f2f7fb;
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;

    .scene-hot-box {
        display: flex;
        flex-direction: row;

        .scene-table-list {
            border: 1px solid #d8e4f0;
            border-top: none;
            min-height: 448px;
        }
        .table {
            th {
                text-align: center !important;
            }
        }
        .first-scene-content {
            flex: 1;
            margin-right: 40px;
        }

        .second-scene-content {
            flex: 1;
        }

        .scene-title {
            padding: 10px 0;
            font-weight: bold;
        }

        .page-control {
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 0;
            text-align: center;
            color: rgba(65, 71, 94, 0.7);
            border-style: solid;
            border-color: #d8e4f0;
            border-width: 0 1px 1px 1px;
        }
    }

    .no-data-tips {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9b9ba3;
    }
}

/deep/.popup-menu-wrapper {
    max-height: 130px;
    width: 160px;
}
</style>
